export default "__VITE_ASSET__5db35608__"